<template>
  <div>
    <v-app-bar
      color="#282a36"
      dark
    >
      <v-toolbar-title>Vuelife</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon href="https://github.com/caiopeternela/pylifeandvuelife" target="_blank">
        <v-icon>mdi-github</v-icon>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "NavBar"
}
</script>
